export const getPlayerName = ({player, firstNameFirst, deletedAt}: {player?: IPlayer; firstNameFirst?: boolean; deletedAt?: Date}) => {
    if (!player) {
        return "Unknown Player";
    }

    const {firstName = '', lastName = '', nickname} = player;

    if (!firstName && !lastName) {
        return `Unknown Player${deletedAt ? " (REMOVED)" : ""}`;
    }

    return `${firstNameFirst ? `${firstName} ${lastName}` : `${lastName}, ${firstName}`}${nickname ? ` (${nickname})` : ""} ${deletedAt ? " (REMOVED)" : ""}`
}
